import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { Link } from "../Link/index.js";
const DialogContent = (t0)=>{
    const $ = c(20);
    const { children, fullScreen, title, titleChip, actions, onClose, withoutPadding: t1, testId } = t0;
    const withoutPadding = void 0 === t1 ? false : t1;
    const pySpace = fullScreen ? "32" : "48";
    const pxSpace = fullScreen ? "16" : "48";
    const t2 = withoutPadding ? "unset" : pySpace;
    const t3 = withoutPadding ? "unset" : pxSpace;
    let t4;
    if ($[0] !== fullScreen || $[1] !== onClose || $[2] !== pxSpace || $[3] !== title || $[4] !== titleChip || $[5] !== withoutPadding) {
        t4 = title && /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "flex-start",
            mb: "24",
            flexDirection: "column",
            px: withoutPadding ? pxSpace : "unset",
            children: [
                fullScreen && /*#__PURE__*/ jsx(Box, {
                    mb: "8",
                    children: /*#__PURE__*/ jsx(Link, {
                        size: "small",
                        onClick: onClose,
                        stroke: false,
                        children: "Назад"
                    })
                }),
                /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "h5",
                            children: title
                        }),
                        titleChip
                    ]
                })
            ]
        });
        $[0] = fullScreen;
        $[1] = onClose;
        $[2] = pxSpace;
        $[3] = title;
        $[4] = titleChip;
        $[5] = withoutPadding;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== children || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ jsxs(Box, {
            py: t2,
            px: t3,
            flexGrow: "1",
            children: [
                t4,
                children
            ]
        });
        $[7] = children;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== actions || $[13] !== fullScreen || $[14] !== withoutPadding) {
        t6 = actions && (fullScreen ? /*#__PURE__*/ jsx(Box, {
            display: "flex",
            justifyContent: "center",
            gap: "16",
            px: withoutPadding ? "unset" : "16",
            pb: "24",
            children: actions
        }) : /*#__PURE__*/ jsx(Box, {
            display: "flex",
            justifyContent: "flex-end",
            gap: "16",
            p: "16",
            bgcolor: "bg.greyscale.primary",
            children: actions
        }));
        $[12] = actions;
        $[13] = fullScreen;
        $[14] = withoutPadding;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== testId) {
        t7 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            flexGrow: "1",
            testId: testId,
            children: [
                t5,
                t6
            ]
        });
        $[16] = t5;
        $[17] = t6;
        $[18] = testId;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};
export { DialogContent };
